/**
 * Ground Truth Health — brand tokens for UI and collateral.
 * Import: `import brand from './assets/brand/tokens'`
 * Design system reference: src/assets/design-system/reference.html
 */
const brand = {
  name: "Ground Truth Health",
  legalName: "Ground Truth Health",
  shortLockup: "gt/h",
  tagline: "Where evidence meets equity.",
  contact: {
    email: "hello@groundtruthhealth.com",
  },

  colors: {
    // Brand
    ink: "#0A0A0A",
    paper: "#FFFFFF",
    bone: "#FAFAF8",
    slash: "#1A6B7C",
    // Aliases used in app UI
    primary: "#1A6B7C",
    background: "#FAFAF8",
    foreground: "#0A0A0A",
    // Neutrals
    gray100: "#F4F4F4",
    gray300: "#E5E5E5",
    gray500: "#C9C9C9",
    gray700: "#9A9A9A",
    gray900: "#6B6B6B",
    rule: "#E5E5E5",
    // Signal / status
    signalGreen: "#00C853",
    signalAmber: "#F59E0B",
    signalRed: "#FF3B30",
  },

  typography: {
    fontMono: "'JetBrains Mono', ui-monospace, monospace",
    fontSans: "'Inter', system-ui, sans-serif",
    fontSerif: "'Newsreader', Georgia, serif",
    // Scale
    display: { family: "serif", size: "96px", weight: 500, lineHeight: 0.96, tracking: "-0.04em" },
    h1:      { family: "serif", size: "44px", weight: 500, lineHeight: 1.05, tracking: "-0.025em" },
    h2:      { family: "sans",  size: "28px", weight: 600, lineHeight: 1.2,  tracking: "-0.02em" },
    body:    { family: "sans",  size: "16px", weight: 400, lineHeight: 1.55, tracking: "-0.005em" },
    mono:    { family: "mono",  size: "14px", weight: 500, lineHeight: 1.4,  tracking: "-0.01em" },
    eyebrow: { family: "mono",  size: "11px", weight: 500, lineHeight: 1.4,  tracking: "0.22em" },
  },

  spacing: {
    sectionY: "96px",
    pageX: "56px",
    maxWidth: "1240px",
  },

  logo: {
    mark: "gt/h",
    slashColor: "#1A6B7C",
    minSizeWeb: "24px",
    minSizePrint: "8mm",
    clearspace: "height of lowercase 'g'",
  },
};

export { brand };
export default brand;
